const RunwayLoadingLabel = ({ children }) => (
  <>
    {children}
    <span className="beaming-dots" aria-hidden="true">
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
    </span>
  </>
);

export const PrimaryButton = ({ children, className = "", disabled = false, loading = false, loadingLabel = "Loading", ...props }) => {
  return (
    <button
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`photon-button-primary border-button-border rounded-lg py-[10px] px-[16px] text-button-on-primary text-sm font-semibold bg-button-primary disabled:opacity-50 ${loading ? "disabled:!opacity-100" : ""} ${className}`}
      {...props}
    >
      {loading ? <RunwayLoadingLabel>{loadingLabel}</RunwayLoadingLabel> : children}
    </button>
  );
};

export const SecondaryButton = ({ children, className = "", disabled = false, loading = false, loadingLabel = "Loading", ...props }) => {
  return (
    <button
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`photon-button-secondary border-button-primary dark:bg-button-secondary-surface border-[0.5px] rounded-lg py-[10px] px-[16px] text-button-primary text-sm font-semibold ${loading ? "disabled:!opacity-100" : ""} ${className}`}
      {...props}
    >
      {loading ? <RunwayLoadingLabel>{loadingLabel}</RunwayLoadingLabel> : children}
    </button>
  );
};

export const ThirdButton = ({ children, className = "", ...props }) => {
  return (
    <button
      className={`photon-button-quiet rounded-lg py-[10px] px-[16px] text-sm font-semibold ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export const CompactButton = ({ children, className = "", disabled = false, ...props }) => {
  return (
    <button
      disabled={disabled}
      className={`photon-button-secondary photon-button-compact flex items-center gap-1 text-xs px-3 py-1 rounded-md font-medium transition-colors border ${
        disabled 
          ? 'border-button-disabled-border text-button-disabled-text cursor-not-allowed'
          : 'border-button-primary text-button-primary hover:bg-button-primary/5'
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export const CompactPrimaryButton = ({ children, className = "", disabled = false, ...props }) => (
  <button
    disabled={disabled}
    className={`photon-button-primary photon-button-compact flex items-center gap-1 rounded-md bg-button-primary px-3 py-1.5 text-xs font-medium text-button-on-primary transition-colors hover:bg-button-primary/90 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const CompactDangerButton = ({ children, className = "", disabled = false, ...props }) => (
  <button
    disabled={disabled}
    className={`photon-button-danger photon-button-compact flex items-center gap-1 rounded-md border border-button-danger-border px-3 py-1.5 text-xs font-medium text-button-danger-text transition-colors hover:bg-button-danger-hover disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-button-danger-hover/20 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const CompactWarningButton = ({ children, className = "", disabled = false, ...props }) => (
  <button
    disabled={disabled}
    className={`photon-button-warning photon-button-compact flex items-center gap-1 rounded-md bg-button-warning px-3 py-1.5 text-xs font-medium text-button-on-primary transition-colors hover:bg-button-warning-hover disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    {...props}
  >
    {children}
  </button>
);
